import React from 'react'

export default function SourceImagePopup({ imageSourceForPopup }) {
  return imageSourceForPopup ? (
    <img
      style={{
        width: '90%',
        height: '90%',
        objectFit: 'contain', // Maintain aspect ratio
      }}
      alt="scannableqrorotherimage"
      src={imageSourceForPopup}
    />
  ) : (
    <div>ERR: Unable to locate source image. Please contact AUMHUM support.</div>
  )
}
